<template>
  <el-table-column
    prop="net_price"
    sortable="custom"
    label="Nettó ár"
    show-overflow-tooltip
    min-width="150"
  >
    <template slot-scope="scope">
      <span>{{ scope.row.net_price | currency }}</span>
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'net_price',
  };
</script>
